<template>
  <div class="weui-msg">
    <div>
      <div v-if="showProcessToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">登录信息失效，正在跳往登录页...</p>
        </div>
      </div>
      <div v-if="showtip">
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">拒绝访问</h2>
            <p class="weui-msg__desc">{{errorMsg}}</p>
        </div>
        <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
                <a @click.prevent="closePage" class="weui-btn weui-btn_primary">关闭</a>
            </p>
        </div>
      </div>
    </div>
    <div class="weui-msg__extra-area">
        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">南京微沐软件科技有限公司</a>
            </p>
            <p class="weui-footer__text">Copyright © 2025-{{ new Date().getFullYear() }} </p>
        </div>
    </div>
  </div>


</template>
<script>
  import wx from 'weixin-js-sdk'
  export default {
    data () {
      return {
        showtip: false,
        showProcessToast: false,
        errorMsg: '',
        appid: 'ww88e428dd4ee7dc4f',
        responseType: 'code',
        scope: 'snsapi_base',
        contractUrl: '',
        contractParam: '',
        agentid: ''
      }
    },
    methods: {
      closePage () {
        wx.closeWindow()
      },
      openAuthPage (redirectUri = encodeURI(window.location.origin)) {
        let url = decodeURIComponent(this.$route.query.url)
        if (url.indexOf('sealOut') !== -1 || url.indexOf('listSealOut') !== -1) {
          this.contractParam = encodeURIComponent(url.split('#')[1])
        }
        let authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'
        let authParams = '?scope=' + this.scope + '&agentid=' + this.agentid + '&appid=' + this.appid + '&redirect_uri=' + redirectUri + '&response_type=' + this.responseType + '&state=' + this.contractParam + '#wechat_redirect'
        let authUri = authPageBaseUri + authParams
        window.location.href = authUri
      }
    },
    mounted: function () {
      console.log('navigator:', navigator.userAgent.toLowerCase().indexOf('micromessenger'))
      this.contractUrl = this.$route.query.url
      let url = decodeURIComponent(window.location.href)
      if ((this.contractUrl.indexOf('contract') !== -1 || this.contractUrl.indexOf('sealOut') !== -1) && url.indexOf('code') === -1) {
        this.contractParam = decodeURIComponent(this.contractUrl.split('#')[1].replace(/&/g, '-'))
      }
      let code = ''
      if (url.indexOf('code') !== -1) {
        if (url.indexOf('state') !== -1) {
          this.contractParam = decodeURIComponent(url.split('state=')[1].replace(/-/g, '&'))
          code = url.split('&')[0].split('=')[1]
        } else {
          code = url.split('#')[0].split('=')[1]
        }
        let type = -1
        if (url.indexOf('sealOut') !== -1 || url.indexOf('listSealOut') !== -1) {
          type = 1
        }
        this.$http.get('rest/api/login/?code=' + code).then(res => {
          if (res.data.ok) {
            let userId = res.data.wxUser.userId
            let href = window.location.href
            let id = res.data.wxUser.id
            // 没有绑定用户，去登录绑定页面
            if (userId === -1) {
              this.verifyLogin = false
              this.showProcessToast = false
              window.location.href = href.split('?')[0] + '#/login/' + type + '/' + id
            } else {
              // 该微信用户已经绑定系统用户
              if (this.contractParam.indexOf('contract') !== -1 || this.contractParam.indexOf('sealOut') !== -1) {
                window.location.href = window.location.origin + '/#' + this.contractParam.split('#')[0]
              } else if (url.indexOf('listSealOut') !== -1) {
                window.location.href = href.split('?')[0] + '#/listSealOut/index?showNavbar=true&showBack=false&selected=0&refresh=true'
              } else {
                window.location.href = href.split('?')[0] + '#/list/index?showNavbar=true&showBack=false&selected=0&refresh=true'
              }
            }
          } else {
            this.verifyLogin = false
            this.errorMsg = res.data.msg
            this.showtip = true
          }
        }, res => {
          this.errorMsg = '服务器故障！！！'
          this.showtip = true
          this.verifyLogin = false
        })
      } else {
        // 通过nginx重定向到微信服务器以获取code
        // window.location.href = window.location.origin + '/loginAuthen'
        this.openAuthPage()
      }
    }
}
</script>



// WEBPACK FOOTER //
// loginAuthen.vue?56af0a0e